import { render, staticRenderFns } from "./CostCentres.vue?vue&type=template&id=633376c8&scoped=true&"
import script from "./CostCentres.vue?vue&type=script&lang=js&"
export * from "./CostCentres.vue?vue&type=script&lang=js&"
import style0 from "./CostCentres.vue?vue&type=style&index=0&id=633376c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633376c8",
  null
  
)

export default component.exports